export const contentTableConfig = {
  title: '业务员积分统计',
  propList: [
    {
      prop: 'date',
      label: '日期',
      minWidth: '120',
      slotName: 'date',
      isFixed: true
    },
    { prop: 'usedBy', label: '业务员', minWidth: '100', isFixed: true },
    { prop: 'parentDept', label: '组', minWidth: '100', isFixed: true },
    { prop: 'deptName', label: '部门', minWidth: '100', isFixed: true },
    {
      prop: 'bonus',
      label: '积分',
      minWidth: '100',
      slotName: 'bonus',
      sortable: true,
      isFixed: true
    },
    { prop: 'bigMoney', label: '10W上新资源数',sortable: true, minWidth: '100' },
    { prop: 'age', label: '了解到年龄数', sortable: true, minWidth: '100' },
    { prop: 'contract', label: '签约经历≤2家客户数', sortable: true, minWidth: '100' },
    { prop: 'year', label: '炒股年限≤5年客户数', sortable: true, minWidth: '100' },
    { prop: 'beitao518', label: '518账户被套使用素材客户数', sortable: true, minWidth: '100' },
    {
      prop: 'toujiaoBeitao',
      label: '投教账户被套使用素材客户数',
      sortable: true,
      minWidth: '100'
    },
    { prop: 'money', label: '了解到自有资金量客户数', sortable: true, minWidth: '100' },
    { prop: 'xihao518', label: '518操作喜好使用素材客户数', sortable: true, minWidth: '100' },
    {
      prop: 'toujiaoXihao',
      label: '投教操作喜好使用素材客户数',
      sortable: true,
      minWidth: '100'
    },
    {
      prop: 'callTime',
      label: '当日电话>分钟数',
      sortable: true,
      minWidth: '100',
      slotName: 'callTime'
    },
    { prop: 'callCount', label: '当日电话通数', sortable: true, minWidth: '100' },
    { prop: 'baojia', label: '3月内资源有效介绍服务报价数', sortable: true, minWidth: '100' },
    {
      prop: 'callOk',
      label: '新资源当天10通以上有效通话',
      minWidth: '120',
      slotName: 'callOk'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
